import { PartialTranslation } from '../translations';

export const et: PartialTranslation = {
  newChat: 'Uus vestlus',
  search: 'Otsi',
  user: 'Kasutaja',
  settings: 'Seaded',
  language: 'Keel',
  getHelp: 'Saada abi',
  viewAllPlans: 'Vaata kõiki plaane',
  learnMore: 'Loe rohkem',
  logOut: 'Logi välja',
  chooseLanguage: 'Vali keel',
  chooseYourPreferredLanguage: 'Valige oma eelistatud keel',
  searchLanguages: 'Otsi keeli...',
  autoDetect: 'Automaatne tuvastamine',
  noLanguagesFound: 'Keeli ei leitud',
  askAnything: 'Küsi kõike',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Isiklik',
  freePlan: 'Tasuta plaan',
  current: 'Praegune',
  close: 'Sulge',
  archive: 'Arhiveeri',
  delete: 'Kustuta',
  confirmDelete: 'Kas oled kindel, et soovid selle vestluse kustutada?',
  confirmArchive: 'Kas oled kindel, et soovid selle vestluse arhiveerida?',
  deleteCannotUndo: 'Seda tegevust ei saa tagasi võtta.',
  archiveCanFind: 'Leiate selle arhiivi nimekirjast pärast arhiveerimist.',
  
  // 资源面板
  resources: 'Ressursid',
  addResource: 'Lisa ressurss',
  deleteResource: 'Kustuta ressurss',
  noMatchingResourcesFound: 'Sobivaid ressursse ei leitud',
  noResourcesAvailable: 'Ressursse pole saadaval',
  hideResources: 'Peida ressursid',
  showResources: 'Näita ressursse',
  
  // 聊天输入框
  typeMessage: 'Kirjuta sõnum...',
  thinkingOptions: 'Mõtlemise valikud',
  deleteFile: 'Kustuta fail',
  clearSelection: 'Tühjenda valik',
  addAttachment: 'Lisa manus',
  sendMessage: 'Saada sõnum',
  
  // 思考模式选项
  deepInsight: 'Sügav teadmine · Pealispindne analüüs',
  deepInsightDesc: 'Kiire arusaam võtmepunktidest',
  deepExploration: 'Sügav uurimine · Terviklik analüüs',
  deepExplorationDesc: 'Mitmemõõtmeline põhjalik uurimus',
  deepDeconstruction: 'Sügav dekonstruktsioon · Süsteemne argument',
  deepDeconstructionDesc: 'Kiht-kihilt progressiivne analüüs',
  
  // 写作模式选项
  contractReview: 'Lepingu ülevaatus · Riski tuvastamine',
  contractReviewDesc: 'Klauslite analüüs ja vastavuse kontroll',
  textPolish: 'Teksti viimistlus · Professionaalne väljendus',
  textPolishDesc: 'Keele optimeerimine ja struktuuri korrigeerimine',
  legalDocuments: 'Juriidilised dokumendid · Standardne projekt',
  legalDocumentsDesc: 'Professionaalne juriidiliste dokumentide kirjutamine',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Logi sisse',
  register: 'Registreeru',
  welcomeBack: 'Tere tulemast LawHelperisse',
  loginSubtitle: 'Teie AI õigusuuringute assistent',
  continueWithGoogle: 'Jätka Google\'iga',
  continueWithMicrosoft: 'Jätka Microsoftiga',
  continueWithWeChat: 'Jätka WeChatiga',
  orContinueWith: 'või jätka',
  emailTab: 'E-post',
  phoneTab: 'Telefon',
  emailPlaceholder: 'Sisestage oma e-post',
  phonePlaceholder: 'Sisestage telefoninumber',
  codePlaceholder: 'Sisestage 6-kohaline kood',
  sending: 'Saatmine...',
  verifying: 'Kinnitamine...',
  verify: 'Kinnita',
  sendMagicLink: 'Saada võlulink',
  getVerificationCode: 'Hangi kood',
  resendCode: 'Saada kood uuesti',
  resendIn: 'Saada uuesti',
  magicLinkSent: 'Võlulink saadeti teie e-postile',
  magicLinkHint: 'Saadame teie e-postile turvalise lingi',
  otpSent: 'Kinnituskood saadetud',
  agreeToTerms: 'Jätkates nõustute meie',
  privacyPolicy: 'Privaatsuspoliitika',
  termsOfService: 'Teenuse tingimused',
  and: 'ja',
  privacyTitle: 'Teie privaatsus on oluline',
  privacyIntro: 'Kasutame küpsiseid ja sarnaseid tehnoloogiaid parima kogemuse pakkumiseks.',
  essentialCookies: 'Olulised küpsised',
  essentialDesc: 'Vajalikud veebisaidi toimimiseks',
  analyticsCookies: 'Analüütilised küpsised',
  analyticsDesc: 'Aitavad meil teenust parandada',
  marketingCookies: 'Turundusküpsised',
  marketingDesc: 'Kasutatakse isikupärastatud sisu jaoks',
  acceptAll: 'Nõustu kõigiga',
  essentialOnly: 'Ainult olulised',
  customize: 'Kohanda',
  savePreferences: 'Salvesta eelistused',
  back: 'Tagasi',
  readPrivacyPolicy: 'Loe meie privaatsuspoliitikat',
  cookiePolicy: 'Küpsiste poliitika',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI ülevaade',
  aiDraft: 'AI kavand',
  smartAssistant: 'Mall',

  // 知识库搜索
  enableKnowledgeSearch: 'Luba otsing',
  knowledgeSearchDesc: 'AI otsib teie dokumentidest',
  clickToDisable: 'Keela',
  clickToEnable: 'Luba',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Sulge ressursside paneel',
  uploading: 'Üleslaadimine %{fileName}...',
  processing: 'Töötlemine %{fileName}...',
  uploadSuccess: '✓ %{fileName} üles laaditud',
  uploadError: '✗ Üleslaadimine ebaõnnestus: %{error}',
  quickAnswer: 'Kiire vastus',
  quickAnswerDesc: 'Kiire vastus lihtsatele küsimustele',
  cancelRequest: 'Tühista',
  library: 'Raamatukogu',
  filterAll: 'Kõik',
  filterChat: 'Vestlused',
  filterReview: 'Ülevaate',
  filterDraft: 'Mustand',
  filterTemplate: 'Mall',
  filterForm: 'Vorm',
  thinking: 'Mõtlen...',
  thinkingProcess: 'Mõtlemisprotsess',
  analyzingLegalLogic: 'Õigusliku loogika analüüs...',
  lawhelperThinking: 'Lawhelper mõtleb...',
  serviceError: 'Teenuse viga',
  uploaded: 'Üles laaditud',
  settingsGeneral: 'Üldine',
  settingsNotifications: 'Teavitused',
  settingsAppearance: 'Välimus',
  settingsProfile: 'Profiil',
  settingsResponseNotifications: 'Vastuste teavitused',
  settingsResponseNotificationsDesc: 'Teavitus AI vastuse lõpetamisel',
  settingsColorMode: 'Värvirežiim',
  settingsLight: 'Hele',
  settingsDark: 'Tume',
  settingsSystem: 'Süsteem',
  about: 'Teave',
  reviewTitle: 'Dokumendi ülevaade',
  exitReview: 'Välju ülevaatest',
  uploadPrompt: 'Laadige PDF ülevaateks',
  uploadButton: 'Vali fail',
  startChatConfig: 'Sisestage "Vaata see dokument üle"',
  reviewPlaceholder: 'Sisestage sõnum...',
  analyzing: 'Ülevaatamine...',
  reviewComplete: 'Ülevaade lõpetatud',
  issuesFound: 'Leitud %{count} probleemi',
  draftTitle: 'Õigusdokumendi koostamine',
  draftPlaceholder: 'Muutke siin või paluge AI-l...',
  analyzingTemplate: 'Malli %{name} analüüs...',
  templateAnalyzed: '✅ Mall %{name} analüüsitud!',
  templateAnalysisPrompt: 'Analüüsi põhiklausleid',
  parsingFailed: '⚠️ Faili ei õnnestunud analüüsida.',
  generating: 'Genereerimine...',
  generatedSuccess: '✅ Dokument loodud!',
  drafterWelcome: 'Tere tulemast AI dokumendiassistenti',
  drafterYouCan: 'Saate:',
  drafterUploadTemplate: 'Laadida mall AI analüüsiks',
  drafterDescribeNeeds: 'Kirjeldada dokumendi nõudeid',
  drafterLetAiHelp: 'AI aitab lepingute, kokkulepete jm koostamisel',
  drafterExamples: 'Näited:',
  drafterExampleRental: '"Koostage üürileping"',
  drafterExampleLabor: '"Täitke tööleping"',
  drafterInputPlaceholder: 'Kirjeldage vajadusi...',
  drafterThinking: 'Mõtlen...',
  drafterHistoryTitle: 'Ajalugu',
  drafterNoHistory: 'Ajalugu puudub',
  drafterNewChat: 'Uus vestlus',
  drafterHistory: 'Ajalugu',
  drafterRemoveAttachment: 'Eemalda manus',
  drafterLineHeight: 'Rea kõrgus',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Ekspordi Wordi (.docx)',
  drafterExportPdf: 'Ekspordi PDF-i',
  drafterSave: 'Salvesta dokument',
  drafterDownload: 'Laadi dokument alla',
  drafterUndo: 'Võta tagasi',
  drafterRedo: 'Tee uuesti',
  drafterBold: 'Paks',
  drafterItalic: 'Kaldkiri',
  drafterStrike: 'Läbikriipsutatud',
  drafterUnderline: 'Allajoonitud',
  drafterHighlight: 'Tõsta esile',
  drafterLink: 'Lisa link',
  drafterAlignLeft: 'Vasakule',
  drafterAlignCenter: 'Keskele',
  drafterAlignRight: 'Paremale',
  drafterAlignJustify: 'Rööpjoondus',
  drafterList: 'Loend',
  drafterBulletList: 'Täppide loend',
  drafterOrderedList: 'Numbrite loend',
  drafterTaskList: 'Ülesannete loend',
  drafterOpenResource: 'Ava ressursid',
  drafterStopGeneration: 'Peata genereerimine',
  drafterAgentMode: 'Agendi režiim aktiivne',
  drafterAgentModeOn: 'Agendi režiim aktiivne',
  drafterAgentModeOff: 'Tavaline režiim',
  drafterUploadAttachment: 'Laadi manus üles',
  drafterExit: 'Välju',
  drafterConfirm: 'Kinnita',
  drafterOpenLink: 'Ava link',
  drafterDeleteLink: 'Kustuta link',
  drafterQuote: 'Tsitaat',
  workflowTitle: 'AI töövoog',
  workflowRunning: 'Täitmisel...',
  workflowReady: 'Valmis',
  workflowCompleted: 'Lõpetatud',
  workflowStartFailed: 'Käivitamine ebaõnnestus',
  workflowExecutionFailed: 'Täitmine ebaõnnestus',
  workflowInterrupted: 'Töövoog katkestatud',
  workflowProcessing: 'Töötlemine...',
  workflowStepsCompleted: 'sammu lõpetatud',
  workflowStepsTotal: 'Töövoog lõpetatud (%{count} sammu)',
  acceptChanges: 'Nõustu muudatustega',
  rejectChanges: 'Keeldu muudatustest',
  changesAccepted: 'Muudatused vastu võetud',
  changesRejected: 'Muudatused tagasi lükatud',
  stopWorkflow: 'Peata',
  restartWorkflow: 'Taaskäivita',
  startDrafting: 'Alusta koostamist',
  interrupt: 'Peata',
  documentSubject: 'Dokumendi teema *',
  documentType: 'Dokumendi tüüp',
  jurisdiction: 'Jurisdiktsioon',
  specialRequirements: 'Erinõuded (valikuline)',
  clickStartDrafting: 'Vajutage "Alusta koostamist"',
  docTypeContract: 'Leping',
  docTypeAgreement: 'Kokkulepe',
  docTypeNotice: 'Teade',
  docTypeLetter: 'Kiri',
  docTypePetition: 'Petitsioon',
  docTypeWill: 'Testament',
  docTypePowerOfAttorney: 'Volikiri',
  countryChina: 'Hiina',
  countryUSA: 'USA',
  countryGermany: 'Saksamaa',
  countryJapan: 'Jaapan',
  countryFrance: 'Prantsusmaa',
  countryUK: 'Ühendkuningriik',
  citationVerified: 'Kinnitatud',
  citationUnverified: 'Kinnitamata',
  imageLoadFailed: 'Pildi laadimine ebaõnnestus',
  smartDocTitle: 'Nutikas dokumendiassistent',
  smartDocChatTitle: 'AI dokumendiassistent',
  smartDocDropPrompt: 'Lohistage PDF siia',
  smartDocSelectFile: 'Vali fail',
  smartDocOr: 'või',
  smartDocWelcomeTitle: 'Tere tulemast AI assistenti',
  smartDocWelcomeYouCan: 'Saate:',
  smartDocUploadForAI: 'Laadida mall',
  smartDocDescribeDoc: 'Kirjeldada nõudeid',
  smartDocLetAIDraft: 'AI aitab lepingutega',
  smartDocExamples: 'Näited:',
  smartDocExampleRental: '"Koostage üürileping"',
  smartDocExampleLabor: '"Täitke tööleping"',
  smartDocInputPlaceholder: 'Kirjeldage vajadusi...',
  smartDocRemoveAttachment: 'Eemalda manus',
  smartDocOpenResources: 'Ava ressursid',
  smartDocExit: 'Välju',
  reviewStartFailed: 'Ülevaate käivitamine ebaõnnestus',
  reviewFailed: 'Ülevaade ebaõnnestus',
  reviewFoundIssues: 'Ülevaade lõpetatud, %{count} probleemi.',
  cannotReadStream: 'Voo lugemine ebaõnnestus',
  parseEventFailed: 'Sündmuse analüüs ebaõnnestus',
  errorPrefix: 'Viga',
  unknownError: 'Tundmatu viga',
  file: 'Fail',
  loading: 'Laeb...',
  localFolders: 'Kohalikud kaustad',
  selectLocalFolder: 'Vali kohalik kaust',
  reselectFolder: 'Vaheta kaust',
  addToContext: 'Lisa vestlusesse',
  saveFile: 'Salvesta',
  renameFile: 'Nimeta ümber',
  fileSaved: 'Fail salvestatud',
  fileRenamed: 'Fail ümber nimetatud: %{name}',
  browserNotSupported: 'Brauser ei toeta kaustale juurdepääsu',
  noFolderSelected: 'Valige kohalik kaust',
  scanningFolder: 'Kausta skannimine...',
  selectFileToPreview: 'Valige fail eelvaateks',
  aiAnalyze: 'AI analüüs',
};
